const state = {
  factTable: '',
  dateRange: {
    movableDate: '',
    range: []
  },
  filters: {},
  requestedData: {},
  productDim: [],
  storeDim: [],
  dateDim: [],
  grain: '',
  movableDateOptions: {},
  fileName: {}
}

const getters = {
}

const mutations = {
  setParameter (state, params) {
    let parameter = params.key
    state[parameter] = params.value
  },
  setDims (state, dim, value) {
    state[dim] = value
  },
  setGrain (state, grain) {
    state.grain = grain
  },
  setDateRange (state, params) {
    state.dateRange = {}
    state.dateRange.movableDate = params.movDateStatus
    state.dateRange.range = params.dateRange
  },
  setFilters (state, params) {
    state.filters = params
  },
  setMovableDateOptions (state, data) {
    state.movableDateOptions = data
  }

}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/excelMassiveDownload.js